export default __webpack_public_path__ + "static/gmx-a1a4a0a8930ff478ea612865f52d38d0.png";